export const persistLocalStorage: <T, >(key: string, value: T) => void = (key, value) => {
  localStorage.setItem(key, JSON.stringify({ ...value }))
}

export const clearLocalStorage: (key: string) => void = (key) => {
  localStorage.removeItem(key)
}
